import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import { namespacesWithDDS, sections, } from './helper';
import { getNumberValue } from '../../../../helpers/Number';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { renderAvailabilityTag, placeholder } from '../../helpers';
import { LoadingOutlined } from '@ant-design/icons';

export default function SupplyChainDetails({
  data = {},
  namespace = null,
  getOption = () => { },
  tradeData = {
    mineSites: [],
    suppliers: [],
    customers: [],
  },
  loading,
}) {
  const { t } = useTranslation();

  return (
    <Widget
      title={t('Supply Chain Details')}
    >
      <Style className="default-content">
        <div className="default-section">
          <label className="title">{t('Position in the Supply Chain')}</label>
          {loading ? (
            <div className="flex">
              <LoadingOutlined className="loader-1" />
            </div>
          ) : (
            <div className="wrap">
              {(data.positionInSupplyChain && data.positionInSupplyChain.length) ? data.positionInSupplyChain.filter((s) => !!s).map((s) => (
                <div className="tag" key={`positions-${s}`}>
                  {getOption('positionInMineralSupplyChainOptions', s)}
                </div>
              )) : (
                <div className="tag">
                  {placeholder}
                </div>
              )}
            </div>
          )}
        </div>

        {namespacesWithDDS.includes(namespace) && (
          <div className="default-section">
            <label className="title">{t('Due Diligence Systems')}</label>
            {loading ? (
              <div className="flex">
                <LoadingOutlined className="loader-2" />
              </div>
            ) : renderAvailabilityTag(t, data.dueDiligenceSystems)}
          </div>
        )}

        <div className="sections">
          {sections.map((s, i) => (
            <div
              className={formatClassname(['section', i !== 2 && 'with-border', i === 0 && 'first'])}
              key={`section-${s.key}`}
            >
              <div className="item label">
                <label>{t(s.label)}</label>
              </div>
              <div className="item value">
                <label>
                  {loading ? (
                    <LoadingOutlined className="loader-2" />
                  ) : getNumberValue((tradeData[s.key] || []).length)}
                </label>
              </div>
            </div>
          ))}
        </div>
      </Style>
    </Widget >
  );
}
